module.exports = __webpack_public_path__ + "img/omar-lopez-1qfy-jDc_jo-unsplash.b1f7ae36.jpg";